var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.36 5.62035L11.5652 9.31667C6.56143 10.6574 4.43311 14.3679 5.77827 19.3881L10.3342 36.3909C11.7014 41.4934 15.3821 43.5767 20.3859 42.236L34.1807 38.5397C39.2651 37.1773 41.3288 33.5548 39.9616 28.4523L35.4057 11.4494C34.0605 6.42923 30.4444 4.25799 25.36 5.62035Z",
    fill: "url(#paint0_linear_4314_410)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4314_410)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.9202,
    y: 36.3044,
    width: 22.0066,
    height: 18.6355,
    rx: 6.00002,
    transform: "rotate(-105 15.9202 36.3044)",
    fill: "#94D4FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 3.2259,
    y: 1.79017,
    width: 55.9297,
    height: 59.3378
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6.1px)",
      clipPath: "url(#bgblur_0_4314_410_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 12.2,
    d: "M38.332 14.2049C41.0046 14.2049 43.1145 14.9754 44.5557 16.4344C45.9964 17.893 46.7412 20.0111 46.7412 22.6492V40.2518C46.7412 42.9317 45.9972 45.0548 44.5557 46.5076C43.1139 47.9606 41.0034 48.7137 38.332 48.7137H24.0508C21.4203 48.7137 19.3104 47.9597 17.8584 46.5076C16.4065 45.0555 15.6406 42.9331 15.6406 40.2518V22.6492C15.6406 20.0095 16.4071 17.8913 17.8584 16.4334C19.3098 14.9756 21.4192 14.2049 24.0508 14.2049H38.332Z",
    fill: "#94D4FF",
    fillOpacity: 0.35,
    stroke: "url(#paint1_linear_4314_410)",
    strokeWidth: 0.428573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 20.8855,
    y: 20.2003,
    width: 24.7427,
    height: 26.7474
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.21px)",
      clipPath: "url(#bgblur_1_4314_410_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4314_410)",
    "data-figma-bg-blur-radius": 6.42859
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_4314_410",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5111 37.8334H37.8705C38.5504 37.9016 39.0638 38.4805 39.0638 39.1791C39.0638 39.859 38.5504 40.4401 37.8705 40.5082H24.5111C23.9999 40.5764 23.5054 40.321 23.2328 39.895C22.9602 39.4519 22.9602 38.8893 23.2328 38.4633C23.5054 38.0203 23.9999 37.7823 24.5111 37.8334ZM37.8705 30.061C38.6032 30.061 39.1996 30.6593 39.1996 31.392C39.1995 32.1247 38.6032 32.7211 37.8705 32.7211H24.5111C23.7767 32.7211 23.1821 32.1247 23.182 31.392C23.182 30.6593 23.7767 30.061 24.5111 30.061H37.8705ZM29.6039 22.3432C30.3382 22.3432 30.9348 22.9395 30.9349 23.6703C30.9349 24.4218 30.3383 25.019 29.6039 25.019H24.5111C23.7767 25.019 23.182 24.4216 23.182 23.6889C23.1823 22.9564 23.7768 22.3598 24.5111 22.3598V22.3432H29.6039Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5111 37.8334H37.8705C38.5504 37.9016 39.0638 38.4805 39.0638 39.1791C39.0638 39.859 38.5504 40.4401 37.8705 40.5082H24.5111C23.9999 40.5764 23.5054 40.321 23.2328 39.895C22.9602 39.4519 22.9602 38.8893 23.2328 38.4633C23.5054 38.0203 23.9999 37.7823 24.5111 37.8334ZM37.8705 30.061C38.6032 30.061 39.1996 30.6593 39.1996 31.392C39.1995 32.1247 38.6032 32.7211 37.8705 32.7211H24.5111C23.7767 32.7211 23.1821 32.1247 23.182 31.392C23.182 30.6593 23.7767 30.061 24.5111 30.061H37.8705ZM29.6039 22.3432C30.3382 22.3432 30.9348 22.9395 30.9349 23.6703C30.9349 24.4218 30.3383 25.019 29.6039 25.019H24.5111C23.7767 25.019 23.182 24.4216 23.182 23.6889C23.1823 22.9564 23.7768 22.3598 24.5111 22.3598V22.3432H29.6039Z",
    fill: "url(#paint2_linear_4314_410)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5111 37.8334L24.4941 38.004L24.5026 38.0049H24.5111V37.8334ZM37.8705 37.8334L37.8876 37.6629L37.8791 37.662H37.8705V37.8334ZM39.0638 39.1791H39.2353V39.1791L39.0638 39.1791ZM37.8705 40.5082V40.6797H37.8791L37.8876 40.6788L37.8705 40.5082ZM24.5111 40.5082V40.3368H24.4997L24.4885 40.3383L24.5111 40.5082ZM23.2328 39.895L23.0868 39.9848L23.0884 39.9874L23.2328 39.895ZM23.2328 38.4633L23.3772 38.5557L23.3788 38.5532L23.2328 38.4633ZM37.8705 30.061L37.8705 29.8895H37.8705V30.061ZM39.1996 31.392L39.371 31.392V31.392H39.1996ZM37.8705 32.7211V32.8926H37.8705L37.8705 32.7211ZM23.182 31.392H23.0106L23.0106 31.392L23.182 31.392ZM30.9349 23.6703H31.1064V23.6703L30.9349 23.6703ZM23.182 23.6889L23.0106 23.6888V23.6889H23.182ZM24.5111 22.3598V22.5312H24.6825V22.3598H24.5111ZM24.5111 22.3432V22.1718H24.3397V22.3432H24.5111ZM24.5111 37.8334V38.0049H37.8705V37.8334V37.662H24.5111V37.8334ZM37.8705 37.8334L37.8534 38.004C38.4426 38.0631 38.8924 38.5655 38.8924 39.1791L39.0638 39.1791L39.2353 39.1791C39.2352 38.3955 38.6581 37.7401 37.8876 37.6629L37.8705 37.8334ZM39.0638 39.1791H38.8924C38.8924 39.7729 38.4438 40.2785 37.8534 40.3377L37.8705 40.5082L37.8876 40.6788C38.657 40.6017 39.2353 39.9452 39.2353 39.1791H39.0638ZM37.8705 40.5082V40.3368H24.5111V40.5082V40.6797H37.8705V40.5082ZM24.5111 40.5082L24.4885 40.3383C24.0489 40.3969 23.6171 40.1774 23.3772 39.8025L23.2328 39.895L23.0884 39.9874C23.3938 40.4646 23.951 40.7559 24.5338 40.6782L24.5111 40.5082ZM23.2328 39.895L23.3788 39.8051C23.1394 39.4161 23.1413 38.9243 23.3772 38.5557L23.2328 38.4633L23.0884 38.3709C22.779 38.8543 22.781 39.4878 23.0868 39.9848L23.2328 39.895ZM23.2328 38.4633L23.3788 38.5532C23.6164 38.1671 24.047 37.9593 24.4941 38.004L24.5111 37.8334L24.5282 37.6629C23.9529 37.6053 23.3945 37.8735 23.0868 38.3735L23.2328 38.4633ZM37.8705 30.061L37.8705 30.2324C38.5082 30.2324 39.0282 30.7537 39.0282 31.392H39.1996H39.371C39.371 30.5649 38.6982 29.8896 37.8705 29.8895L37.8705 30.061ZM39.1996 31.392L39.0282 31.392C39.0281 32.03 38.5085 32.5497 37.8705 32.5497L37.8705 32.7211L37.8705 32.8926C38.6979 32.8926 39.3709 32.2194 39.371 31.392L39.1996 31.392ZM37.8705 32.7211V32.5497H24.5111V32.7211V32.8926H37.8705V32.7211ZM24.5111 32.7211V32.5497C23.8716 32.5497 23.3535 32.0302 23.3534 31.392L23.182 31.392L23.0106 31.392C23.0107 32.2192 23.6819 32.8926 24.5111 32.8926V32.7211ZM23.182 31.392H23.3534C23.3534 30.7535 23.8718 30.2324 24.5111 30.2324V30.061V29.8895C23.6815 29.8895 23.0106 30.5651 23.0106 31.392H23.182ZM24.5111 30.061V30.2324H37.8705V30.061V29.8895H24.5111V30.061ZM29.6039 22.3432V22.5146C30.2439 22.5146 30.7634 23.0345 30.7635 23.6704L30.9349 23.6703L31.1064 23.6703C31.1062 22.8444 30.4326 22.1718 29.6039 22.1718V22.3432ZM30.9349 23.6703H30.7635C30.7635 24.3287 30.2421 24.8476 29.6039 24.8476V25.019V25.1904C30.4345 25.1904 31.1064 24.515 31.1064 23.6703H30.9349ZM29.6039 25.019V24.8476H24.5111V25.019V25.1904H29.6039V25.019ZM24.5111 25.019V24.8476C23.8717 24.8476 23.3534 24.3273 23.3534 23.6889H23.182H23.0106C23.0106 24.516 23.6817 25.1904 24.5111 25.1904V25.019ZM23.182 23.6889L23.3534 23.689C23.3537 23.0509 23.8717 22.5312 24.5111 22.5312V22.3598V22.1884C23.682 22.1884 23.0109 22.8619 23.0106 23.6888L23.182 23.6889ZM24.5111 22.3598H24.6825V22.3432H24.5111H24.3397V22.3598H24.5111ZM24.5111 22.3432V22.5146H29.6039V22.3432V22.1718H24.5111V22.3432Z",
    fill: "url(#paint3_linear_4314_410)",
    mask: "url(#path-4-inside-1_4314_410)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4314_410",
    x: -0.0000581741,
    y: 0.00000286102,
    width: 44.1451,
    height: 46.5289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.78573,
    result: "effect1_foregroundBlur_4314_410"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4314_410_clip_path",
    transform: "translate(-3.2259 -1.79017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.332 14.2049C41.0046 14.2049 43.1145 14.9754 44.5557 16.4344C45.9964 17.893 46.7412 20.0111 46.7412 22.6492V40.2518C46.7412 42.9317 45.9972 45.0548 44.5557 46.5076C43.1139 47.9606 41.0034 48.7137 38.332 48.7137H24.0508C21.4203 48.7137 19.3104 47.9597 17.8584 46.5076C16.4065 45.0555 15.6406 42.9331 15.6406 40.2518V22.6492C15.6406 20.0095 16.4071 17.8913 17.8584 16.4334C19.3098 14.9756 21.4192 14.2049 24.0508 14.2049H38.332Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4314_410",
    x: 20.8855,
    y: 20.2003,
    width: 24.7427,
    height: 26.7474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.14286,
    dy: 2.14286
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.14286
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.580392 0 0 0 0 0.831373 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4314_410"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4314_410",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4314_410_clip_path",
    transform: "translate(-20.8855 -20.2003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5111 37.8334H37.8705C38.5504 37.9016 39.0638 38.4805 39.0638 39.1791C39.0638 39.859 38.5504 40.4401 37.8705 40.5082H24.5111C23.9999 40.5764 23.5054 40.321 23.2328 39.895C22.9602 39.4519 22.9602 38.8893 23.2328 38.4633C23.5054 38.0203 23.9999 37.7823 24.5111 37.8334ZM37.8705 30.061C38.6032 30.061 39.1996 30.6593 39.1996 31.392C39.1995 32.1247 38.6032 32.7211 37.8705 32.7211H24.5111C23.7767 32.7211 23.1821 32.1247 23.182 31.392C23.182 30.6593 23.7767 30.061 24.5111 30.061H37.8705ZM29.6039 22.3432C30.3382 22.3432 30.9348 22.9395 30.9349 23.6703C30.9349 24.4218 30.3383 25.019 29.6039 25.019H24.5111C23.7767 25.019 23.182 24.4216 23.182 23.6889C23.1823 22.9564 23.7768 22.3598 24.5111 22.3598V22.3432H29.6039Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_410",
    x1: 18.4618,
    y1: 7.46873,
    x2: 27.2825,
    y2: 40.3881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4314_410",
    x1: 20.7371,
    y1: 18.3892,
    x2: 42.8458,
    y2: 43.0332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4314_410",
    x1: 38.0531,
    y1: 25.6254,
    x2: 20.0358,
    y2: 26.1481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4314_410",
    x1: 25.6025,
    y1: 24.4607,
    x2: 37.4075,
    y2: 37.4689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon25);
export default __webpack_public_path__ + "static/media/icon25.e4d9ac3dca2f5018d1a3c99de01ff909.svg";
export { ForwardRef as ReactComponent };